import Http from "@api/http";

export const authLogin = async (params) => {
  const result = await Http.post("auth/login", params);
  return result;
};

export const regist = async (params) => {
  try {
    const rs = await Http.post("register/member", params);
    return rs;
  } catch (error) {
    return error;
  }
};

export async function profileUpdate(params) {
  try {
    const rs = await Http.post("me/update", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function getProfile() {
  try {
    const rs = await Http.get("me");
    return rs;
  } catch (error) {
    return error;
  }
}

export async function updateTemporaryInfo(params) {
  try {
    const rs = await Http.put("me/update/temporary-info", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function profileUpdateOfficial(params) {
  try {
    const rs = await Http.post("me/update/official", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function profileUpdateOfficial1(params) {
  try {
    const rs = await Http.post("me/update/official1", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function profileUpdateOfficial2(params) {
  try {
    const rs = await Http.post("me/update/official2", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function profileUpdateOfficial3(params) {
  // eslint-disable-next-line no-useless-catch
  try {
    const rs = await Http.post("me/update/official3", params);
    return rs;
  } catch (error) {
    throw error;
  }
}

export async function storePushNotification(params) {
  try {
    const rs = await Http.post("me/push-notification/store", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function updateDetailPushNotification(params) {
  try {
    const rs = await Http.post("me/push-notification/update-detail", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function deletePushNotification(params) {
  try {
    const rs = await Http.post("me/push-notification/delete", params);
    return rs;
  } catch (error) {
    return error;
  }
}

export async function getStaffNotificationDetail() {
  try {
    const rs = await Http.get("me/push-notification/get-detail");
    return rs;
  } catch (error) {
    return error;
  }
}

export async function logNotification(params) {
  try {
    const rs = await Http.post("/log-notification", params);
    return rs;
  } catch (error) {
    return error;
  }
}
